const actions = {
  LOAD_DOCUMENTS: "LOAD_DOCUMENTS",
  
  CHANGE_DOCUMENT_FILE: "CHANGE_DOCUMENT_FILE",
  
  SET_DOCUMENT_ITEM: "SET_DOCUMENT_ITEM",

  SET_DOCUMENT_ITEM_VALUE: "SET_DOCUMENT_ITEM_VALUE",
  LOAD_DOCUMENT_JOURNAL: "LOAD_DOCUMENT_JOURNAL",
  DOCUMENTS_ARE_LOADING: "DOCUMENTS_ARE_LOADING",
  DOCUMENT_IS_SUBMITTING: "DOCUMENT_IS_SUBMITTING",
  DOCUMENT_CREATE_FAILED: "DOCUMENT_CREATE_FAILED",
  DOCUMENT_CLEAN_ERRORS: "DOCUMENT_CLEAN_ERRORS",

  LIMIT_MAX_SIZE: "LIMIT_MAX_SIZE"
};
export default actions;



// WEBPACK FOOTER //
// ./src/redux/constants/admin/documents.js